// removed by extract-text-webpack-plugin
module.exports = {"container":"_16-q6-uEsy93bWYdulv6KP","loader":"_2tOOsjgqq6DX6rPEdu2wMW"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Spinner/styles.scss
// module id = 606
// module chunks = 11